import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import ConfirmCollectInformationModal from "../employers/ConfirmCollectInformationModal"
import { Button, Table, Tooltip } from "antd";
//import Data from "../../assets/jsons/user";
import {
  onShowSizeChange,
  itemRender,
  showTotal
} from "../_components/paginationfunction";
import api from "../api/api"

import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";
import AddEmployer from "./AddEmployer";
import EmployerManagementMobile from "./EmployerManagementMobile";

const EmployerManagement = () => {
  const {user} = useAuth();
  const history = useHistory();
  const { t } = useTranslation();
  useEffect(()=>{
      fetchData()
  },[])

  const handleCollect = (record) => {
    // Handle collect information logic here
    setSelectedEmployer(record);
  };
  const [loadingAgencies, setloadingAgencies] = useState(false);
  const [error, setError] = useState(null);

  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);

  const [selectedEmployer, setSelectedEmployer] = useState(null);

  const fetchData = async (page = 1) => {

    setloadingAgencies(true)
    setError(null)
    
    try {
      let typeurl = `/employer-management/?page=${page}`;

      const response = await api.get(typeurl); // No need to wrap `data` in an object

      
      setData(response.data.results)
      setNextPage(response.data.next)
      setPrevPage(response.data.previous)
      setCount(response.data.count)

    } catch (error) {
      //console.error("Error submitting form:", error);
      console.log( error);
      // Extract response code if available
      const responseCode =  "Unknown";
      
      setError(responseCode)
      
    } finally {
      setloadingAgencies(false);
    }
  }

  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil(count / 10)) return;

    setCurrentPage(page);
    fetchData(page);
  };

  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const columns = [
    {
      title: "#",
      //dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: false,
    },
    {
      title: t("Action"),
      dataIndex: "id",
      render: (text, record) => {
        return (
          <div className="d-flex gap-2 flex-wrap">
            <Link className="btn btn-sm btn-greys" to={`/employer/${record.id}/profile`}>
              <i className="fa fa-eye me-1"></i>
              {t("View")}
            </Link>
            <Link className="btn btn-sm btn-outline-secondary" to={`/employer/${record.id}/links`}>
              <i className="fa fa-link me-1"></i>
              {t("Link Biodata List")}
            </Link>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              data-bs-toggle="modal"
              data-bs-target="#confirmCollectModal"
              onClick={() => { handleCollect(record); }}
            >
              <i className="fa fa-download me-1"></i>
              {t("Collect Information")}
            </button>
          </div>
        )
      }
    },
    {
      title: t("Employer Name"),
      dataIndex: "name",
      render: (img, record) => (
        <div>
          <h2 className="table-avatar">
            <Link to={`/employer/${record.id}/profile`}>
              {record.name} 
            </Link>
          </h2>
        </div>
      ),
    },
    {
      title: t("Email") ,
      dataIndex: "email",
      
    },
    {
      title: t("Contact"),
      dataIndex: "phone",
      
    },
    {
      title: t("Created By"),
      dataIndex: "created_by",
    },
    {
      title: t("Created Date"),
      dataIndex: "created_at",
      
    },
  ];
  
  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
        window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
        {
                (loadingAgencies || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingAgencies && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
            )}
          </div>
        ) : (
             <> 
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header ">
                <h5>{t("Employer Management")}</h5>

                    <div className="list-btn">
                      <ul className="filter-list">
        

                        <li>
                          <a
                            className="btn btn-primary"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#add_employer"
                          >
                            <i
                              className="fa fa-plus-circle me-2"
                              aria-hidden="true"
                            />
                            {t("Add Employer")}
                          </a>
                        </li>
                      </ul>
                    </div>
              
              </div>
            </div>
            {/* /Page Header */}
            
            {data.length === 0 && (
              <div className="text-center mt-5 py-5">
                <div className="mb-4">
                  <div className="mb-3">
                    <i className="fas fa-briefcase text-muted" style={{fontSize: '4rem', opacity: 0.3}}></i>
                  </div>
                  <h4 className="text-muted mb-2">{t("No Employers Available")}</h4>
                  <p className="text-muted mb-4">{t("You haven't added any employers yet. Start by adding your first employer.")}</p>
                </div>
                <div className="d-flex gap-3 justify-content-center flex-wrap">
                  <a
                    className="btn btn-primary px-4 py-2 rounded-pill shadow-sm"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#add_employer"
                  >
                    <i className="fas fa-plus me-2"></i>
                    {t("Add Employer")}
                  </a>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-sm-12">
                {isMobileDevice() || screenWidth <= 576 ? (
                  <>
                    <EmployerManagementMobile handleCollect={handleCollect} handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count}  data={data} screenWidth={screenWidth}/>
                  </>
                ) : (
                  <div className="card-table">
                    <div className="card-body">
                      <div className="table-responsive table-hover">
                        <Table
                          pagination={{
                            total: count,
                            current: currentPage,                            
                            onShowSizeChange: onShowSizeChange,
                            showTotal: (length,range) => showTotal(t,length, range),
                            itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                          }}
                          columns={columns}
                          dataSource={data}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

         
          </div>
          </>
        )
      }
        </div>

      
      {/* add agency */}
      <AddEmployer refreshData={()=>fetchData()} onRefresh={fetchData}/>
      {/* add agency */}
      {/* confirm modal */}
      <ConfirmCollectInformationModal employer={selectedEmployer} refresh={fetchData} />

      </div>
    </>
  );
};


export default EmployerManagement;
